<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { setLocale } from '@/plugins/i18n'
import { useLocale } from '@/composables/useLocale'
import BSelect from '@/components/base/BSelect/BSelect.vue'

const { t } = useI18n()
const { allLocales, currentLocale, locale } = useLocale()

function onLocaleChange(code: unknown) {
  if (typeof code === 'string') {
    void setLocale(code)
  }
}
</script>

<template>
  <div>
    <div class="py-3">
      <h2 class="text-headline-small">{{ t('common.language') }}</h2>
    </div>

    <b-select
      :model-value="locale"
      :items="allLocales"
      item-title="name"
      item-value="code"
      hide-details
      @update:model-value="onLocaleChange"
    >
      <template #selection>
        <div class="d-flex align-center">
          <v-icon :class="`flag fi fi-${currentLocale.flag}`" />
          <span class="ml-2">{{ currentLocale.name }}</span>
        </div>
      </template>

      <template #item="{ item, props: itemProps }">
        <v-list-item
          v-bind="itemProps"
          class="d-flex align-center justify-space-between w-100"
        >
          <template #title>
            <div class="d-flex align-center">
              <v-icon
                :class="`flag fi fi-${item.flag}`"
                class="mr-3"
                size="22"
              />
              <span>{{ item.name }}</span>
            </div>
          </template>

          <template
            v-if="item.isMachineTranslated"
            #subtitle
          >
            <span class="text-body-small text-disabled">
              {{ t('common.machine_translated_language') }}
            </span>
          </template>
        </v-list-item>
      </template>
    </b-select>
  </div>
</template>
